import React from 'react';
import SetupLeaveUploadFunctional from '../../setup-leave-approval/leave-upload-functional';

const LeaveUpload = () => {
	return <SetupLeaveUploadFunctional {...{ isleaveApproveUpload: true, isSetup: false }} />;
};

export default LeaveUpload;
